import { KindeAccessToken } from "@kinde-oss/kinde-auth-nextjs/types";

export enum Role {
  Admin = "admin",
  SuperAdmin = "super-admin",
}

export const isRole = (role: Role, accessToken: KindeAccessToken): boolean => {
  return (
    accessToken?.roles?.some((r) => {
      if (r.key === role) {
        return true;
      }
      return false;
    }) || false
  );
};
